module.exports = __webpack_public_path__ + "img/IMG_1454_FoamcoreMatted.6635f508.jpg";